import { render } from "./AllHospitals.vue?vue&type=template&id=4101b968"
import script from "./AllHospitals.vue?vue&type=script&lang=js"
export * from "./AllHospitals.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/hospitals/AllHospitals.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4101b968"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4101b968', __exports__)) {
    console.log('reload')
    api.reload('4101b968', __exports__)
  }
  
  module.hot.accept("./AllHospitals.vue?vue&type=template&id=4101b968", () => {
    console.log('re-render')
    api.rerender('4101b968', render)
  })

}


export default __exports__